const constructCID = (num) => {
    const padZero = String(num)?.padStart(8, "0");
    const padEight = padZero?.padStart(9, "8");
    return padEight;
};

export { constructCID };
